import { render, staticRenderFns } from "./mainModal.vue?vue&type=template&id=36b3d768&scoped=true&"
import script from "./mainModal.vue?vue&type=script&lang=js&"
export * from "./mainModal.vue?vue&type=script&lang=js&"
import style0 from "./mainModal.vue?vue&type=style&index=0&id=36b3d768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b3d768",
  null
  
)

export default component.exports